const ID_DOCUMENT_TYPES = {
  PASSPORT: {
    value: "passport",
    readableName: "Passport",
  },
  DRIVERS_LICENSE: {
    value: "drivers_license",
    readableName: "Drivers license",
  },
  NATIONAL_IDENTITY_CARD: {
    value: "national_identity_card",
    readableName: "National Identity Card",
  },
  HEALTH_CARD: {
    value: "health_card",
    readableName: "Health Card",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

// Convert the object to an array of entries
export const idDocumentTypesArray = Object.values(ID_DOCUMENT_TYPES);
